module.exports = __webpack_public_path__ + "static/media/VID_20170101_000230.0b91a571.mp4";